import React from "react";

import {
  getLoyaltyRewardTypeCounts,
  LoyaltyLevelReward,
} from "store/liveOps/loyalty/levels/rewards";
import Tooltip from "components/Tooltip";

import styles from "./LoyaltyRewardTypeLabels.module.scss";

interface Props {
  rewards?: LoyaltyLevelReward[];
}

const VISIBLE_REWARD_TYPES = 2;

const LoyaltyRewardTypeLabels: React.FC<Props> = ({ rewards = [] }) => {
  const counts = getLoyaltyRewardTypeCounts(rewards);
  if (counts.length === 0) return <>—</>;

  const visibleCounts = counts.slice(0, VISIBLE_REWARD_TYPES);
  const hiddenCounts = counts.slice(VISIBLE_REWARD_TYPES);
  const hiddenRewardsCount = hiddenCounts.length;
  const rewardLabel = ({ type, count }: (typeof counts)[number]) =>
    `${type}${count > 1 ? ` ×${count}` : ""}`;

  return (
    <div className={styles.labels}>
      {visibleCounts.map(({ type, count }) => (
        <span className="badge badge--info" key={type}>
          {type}
          {count > 1 ? ` ×${count}` : ""}
        </span>
      ))}
      {hiddenCounts.length > 0 && (
        <Tooltip
          text={hiddenCounts.map(rewardLabel).join(", ")}
          position="top"
          asChild
        >
          <button
            className={styles.more}
            type="button"
            aria-label={`Show ${hiddenRewardsCount} more reward types`}
          >
            +{hiddenRewardsCount}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default LoyaltyRewardTypeLabels;
